import React from 'react';
import Text from '../Text/Text';
import BaseClickable, {
  BaseClickableProps,
} from '../BaseClickable/BaseClickable';

type AlertActionProps = BaseClickableProps;

const AlertAction = ({
  children,
  type = 'button',
  ...rest
}: AlertActionProps) => {
  return (
    <BaseClickable type={type} pt={1} {...rest}>
      <Text
        variant="body2"
        style={{
          textDecoration: 'underline',
          color: 'var(--action-text-color)',
        }}
      >
        {children}
      </Text>
    </BaseClickable>
  );
};

export default AlertAction;
